export default __webpack_public_path__ + "static/media/4.06d34719.jpeg";